module.exports = __webpack_public_path__ + "static/media/paymentpage_percent.b8a7ae55.png";